import { createSlice } from '@reduxjs/toolkit'
import type { ResLocation } from './types'
import type { RootState } from '..'
import { setOneWay, updateCurrentlyEditing } from './resEditFormSlice'
const initialState: ResLocation = {
	collectionAddress: {
		addressType: null,
		address: null,
		id: null,
	},
	deliveryAddress: {
		addressType: null,
		address: null,
		id: null,
	},
	sameAsStart: false,
	userLocation: {},
	geoErrorMessage: null,
}

export const reservationLocationSlice = createSlice({
	name: 'resLocation',
	initialState,
	reducers: {
		resetLocationTimeValues() {
			return initialState
		},
		setGeoMessage(state, action) {
			state.geoErrorMessage = action.payload
		},
		setUserLocation(state, action) {
			state.userLocation = action.payload
		},
		updateSameAddress(state, action) {
			if (action.payload) {
				state.collectionAddress = {
					addressType: 'Same',
					address: state.deliveryAddress.address,
					id: null,
				}
				state.deliveryAddress = {
					...state.collectionAddress,
				}
				state.sameAsStart = true
			} else {
				state.collectionAddress = {
					address: null,
					id: null,
					addressType: null,
				}
				state.sameAsStart = false
			}
		},
		updateAddress(state, action) {
			const {
				type,
				addressType,
				id,
				address,
				latLong,
			}: { type: 'collection' | 'delivery'; addressType: string; id: string; address: { [key: string]: string }; latLong: string } =
				action.payload

			if (state.sameAsStart) {
				state.collectionAddress.addressType = 'Same'
				state.collectionAddress.address = { ...address, latLong }
				state.collectionAddress.id = null
				state.deliveryAddress.addressType = addressType
				state.deliveryAddress.id = id
				state.deliveryAddress.address = { ...address, latLong }
			} else {
				state[`${type}Address`].addressType = addressType
				state[`${type}Address`].address = { ...address, latLong }
				state[`${type}Address`].id = id
			}
		},
	},
	extraReducers(builder) {
		builder.addCase(updateCurrentlyEditing, (_, action) => {
			if (action.payload === false) {
				return initialState
			}
		})
	},
})
export const selectResLocation = (state: RootState) => state.resLocation

export const reservationLocationSliceReducer = reservationLocationSlice.reducer

export const { updateAddress, updateSameAddress, setUserLocation, setGeoMessage, resetLocationTimeValues } =
	reservationLocationSlice.actions
